'use client';

import clsx from 'clsx';
import dynamic from 'next/dynamic';
import loadingAnimation from "../../../../../public/images/lotties/loading.json";
import { useTranslationDetector } from '@/hooks/useTranslationDetector';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

/**
 * Filtre yükleme durumunda gösterilen loader komponenti.
 * Filtreler tetiklendiğinde ekrana çıkar ve otel listesi dönünce kaybolur.
 * 
 * @param {Object} props
 * @param {boolean} props.loading - Yükleme durumu
 * @param {string} props.className - Ek CSS sınıfları
 */
export default function FilterLoader({ loading = true, className = '', innerClassName = '' }) {
    const t = useTranslationDetector('hotel');

    if (!loading) return null;

    return (
        <div className={clsx('flex items-center justify-center w-full z-10 pointer-events-none h-0', className)} style={{ position: 'sticky', top: '8rem' }}>
            <div className={clsx("flex items-center justify-start gap-[18px] bg-white shadow-xl rounded-full py-3 pl-3 pr-6 pointer-events-auto mt-[280px]", innerClassName)}>
                <div className="h-12 w-12 shrink-0">
                    <Lottie animationData={loadingAnimation} loop={true} autoplay={true} />
                </div>
                <span className="text-sm font-semibold text-foreground truncate">
                    {t('resultsLoading')}
                </span>
            </div>
        </div>
    );
}

